module.exports = __webpack_public_path__ + "static/media/Don_Os_Home_Bio-min.08d74c6c.jpg";